import React from "react";
import ModaArticoliBrowser from "./ModaArticoliBrowser";
import useSchedaArticolo from "../modificaProdotti/schedaArticolo/useSchedaArticolo";
import SchedaArticoloOverlay from "../modificaProdotti/schedaArticolo/SchedaArticoloOverlay";

// Stato di backfill e pubblicazione VIG/BOT degli articoli, con i filtri di
// uiPubblicazione. Il codice VS apre la scheda articolo come in Avanzamento backfill.
function StatoArticoliContent({ utente, token, mobile, setProductFunction, listaNomiProdotto }) {
  const scheda = useSchedaArticolo({ setProductFunction });
  return <>
    <ModaArticoliBrowser key="statoArticoli" variante="statoArticoli" utente={utente} token={token} mobile={mobile} />
    {scheda.articolo != null && <SchedaArticoloOverlay scheda={scheda} utente={utente}
      setProductFunction={setProductFunction} listaNomiProdotto={listaNomiProdotto} />}
  </>;
}

export default function StatoArticoliPage(props) {
  if (!props.utente?.permessiAPI?.["read:database"]) {
    return <div className="pa3" role="alert">Per consultare lo stato articoli serve il permesso read:database.</div>;
  }
  return <StatoArticoliContent {...props} />;
}
